'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Heading = exports.Heading = (0, _components2.default)({
  is: 'h2',
  fontSize: 5,
  fontWeight: 'bold',
  lineHeight: 1.25,
  m: 0
}, 'fontFamily', 'fontSize', 'fontWeight', 'lineHeight', 'space', 'color', 'textAlign');
Heading.displayName = 'Heading';

Heading.h1 = function (props) {
  return _react2.default.createElement(Heading, _extends({}, props, {
    is: 'h1'
  }));
};

Heading.h2 = function (props) {
  return _react2.default.createElement(Heading, _extends({}, props, {
    is: 'h2'
  }));
};

Heading.h3 = function (props) {
  return _react2.default.createElement(Heading, _extends({}, props, {
    is: 'h3'
  }));
};

Heading.h4 = function (props) {
  return _react2.default.createElement(Heading, _extends({}, props, {
    is: 'h4'
  }));
};

Heading.h5 = function (props) {
  return _react2.default.createElement(Heading, _extends({}, props, {
    is: 'h5'
  }));
};

Heading.h6 = function (props) {
  return _react2.default.createElement(Heading, _extends({}, props, {
    is: 'h6'
  }));
};

exports.default = Heading;